import { Component } from "react";
import type { ReactNode } from "react";

interface Props {
  onError?: () => void;
  fallback: ReactNode;
  children: ReactNode;
}

interface State {
  rota: boolean;
}

// Puerto directo de ErrorBoundaryPreview.tsx del hermano "AI Video editor"
// (generico, sin cambios): contiene errores de render del preview vivo
// (fallo al montar el chunk LivePreviewFlyer, o cualquier excepcion que
// escape del componente Flyer real fuera del boundary interno de
// @remotion/player) sin tumbar el resto del editor.
export class ErrorBoundaryPreview extends Component<Props, State> {
  state: State = { rota: false };

  static getDerivedStateFromError(): State {
    return { rota: true };
  }

  componentDidCatch(error: unknown): void {
    console.warn("Preview vivo del editor de flyer: fallo de render", error);
    this.props.onError?.();
  }

  render(): ReactNode {
    if (this.state.rota) return this.props.fallback;
    return this.props.children;
  }
}
